import { getStoreIssue } from 'src/utils/firebase/firebase-short-cut';
import useSWRImmutable from 'swr/immutable';

const useSWRStoreIssue = (storeIssueId: string | null) => {
  const {
    data: storeIssue,
    isLoading,
    error,
    mutate,
  } = useSWRImmutable(storeIssueId ? `storeIssue-${storeIssueId}` : null, () => getStoreIssue(storeIssueId as string));

  return {
    storeIssue,
    isLoading,
    error,
    refresh: () => mutate(),
  };
};

export default useSWRStoreIssue;
